






import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { VideoType } from '~/types/solepro/PageBuilder';
import ClientOnly from 'vue-client-only'

export default defineComponent({
    name: 'Video',
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<VideoType>,
            required: true
        }
    },
    components:{
        ClientOnly
    },
    data(){
        return {
            alignment: 'flex justify-center'
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        let videoContent = content.videoContent
        if(content.videoContent.includes('players.brightcove')){
            videoContent = content.videoContent.replace('class="pagebuilder-video-container','class="pagebuilder-video-container aspect-video')
            .replace('<video','<iframe').replace('/video>','/iframe>')
            .replace('frameborder="0"','autoplay muted loop allow="encrypted-media" loading="lazy" class="h-full w-full"')
            .replace('pagebuilder-video-inner','pagebuilder-video-inner w-full')
        }else{
            videoContent = content.videoContent.replace('<video ','<video muted loop ');
        }
        return {
            content,
            videoContent
        }
    },
    mounted(){/*
        let contentAlignment = 'flex';
            if(this.$el) switch (getComputedStyle(this.$el).textAlign) {
                case 'left': contentAlignment += ' justify-start'; break;
                case 'right': contentAlignment += ' justify-end'; break;
                default: contentAlignment += ' justify-center';
            }
            this.alignment = contentAlignment;*/
    }
    
})
